<template>
  <basic-dialog :show="show" @close="$emit('close')" max-width="900px">
    <template v-slot:title>{{ title }}</template>
    <v-row align="center">
      <v-col sm="8">
        <v-text-field
          label="Name"
          v-model="name"
          :outlined="outlinedInputs"
          hide-details
        ></v-text-field>
      </v-col>
      <v-col>
        <route-poi-type-select
          v-model="type"
          :outlined="outlinedInputs"
        ></route-poi-type-select>
      </v-col>
    </v-row>
    <v-row>
      <GmapMap
        ref="gmap"
        :center="center"
        :zoom="15"
        style="width: 100%; height: 400px"
        @click="onMapClick"
      >
        <gmap-marker
          v-if="marker"
          :position="marker"
          :clickable="true"
          :draggable="true"
          @dragend="onDragEnd"
          :icon="icon"
        ></gmap-marker>
        <gmap-polyline :path="path" ref="polyline"></gmap-polyline>
      </GmapMap>
    </v-row>
    <v-row v-if="!marker">
      <v-col>
        <v-alert type="info">Click on the map to add POI</v-alert>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <v-text-field
          label="Lng"
          v-model="lng"
          hide-details
          :outlined="outlinedInputs"
        ></v-text-field>
      </v-col>
      <v-col>
        <v-text-field
          label="Lat"
          v-model="lat"
          hide-details
          :outlined="outlinedInputs"
        ></v-text-field>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <v-slider
          v-model="radius"
          class="align-center"
          :max="10000"
          :min="100"
          hide-details
          label="Radius in meters"
          step="10"
        >
          <template v-slot:append>
            <v-text-field
              v-model="radius"
              class="mt-0 pt-0"
              hide-details
              single-line
              type="number"
              style="width: 90px"
              :outlined="outlinedInputs"
            ></v-text-field>
          </template>
        </v-slider>
      </v-col>
      <v-col sm="2"><v-switch label="Audio" v-model="audio"></v-switch></v-col>
    </v-row>
    <v-row>
      <v-col>
        <v-textarea
          label="Description"
          v-model="description"
          :outlined="outlinedInputs"
          hide-details
          rows="3"
        ></v-textarea>
      </v-col>
    </v-row>
    <v-row> </v-row>
    <div v-if="debug">
      <code>
        {{ type }}
      </code>
    </div>
    <template v-slot:actions>
      <v-btn color="primary" @click="onSave" :disabled="!isValid">Save</v-btn>
    </template>
  </basic-dialog>
</template>

<script>
import BasicDialog from "../../shared/BasicDialog";
import RoutePoiTypeSelect from "./RoutePoiTypeSelect";
export default {
  name: "poi-dialog",

  props: {
    show: {
      type: Boolean,
      default: () => false,
    },
    value: {
      type: Object,
      default: () => false,
    },
    mapCenter: {
      type: Object,
      default: () => null,
    },
    path: {
      type: Array,
      default: () => null,
    },
  },

  components: { BasicDialog, RoutePoiTypeSelect },

  data() {
    return {
      debug: false,
      name: this.value ? this.value.name : "",
      description: this.value ? this.value.description : "",
      lng: this.value ? this.value.lng : "",
      lat: this.value ? this.value.lat : "",
      audio: this.value && this.value.audio,
      radius: 100,
      type: this.value ? { ...this.value.type } : {},
    };
  },

  computed: {
    title() {
      return this.name != "" ? this.name : "New POI";
    },
    outlinedInputs() {
      return this.$store.getters.localSettings("outlinedInputs");
    },
    center() {
      return this.mapCenter ? this.mapCenter : null;
    },
    marker() {
      return this.lat != "" && this.lng != ""
        ? { lat: Number(this.lat), lng: Number(this.lng) }
        : null;
    },
    isValid() {
      return (
        this.name != "" &&
        this.lng &&
        this.lng != "" &&
        this.lat &&
        this.lat != "" &&
        this.type &&
        this.type.id
      );
    },
    old_icon() {
      return this.type && this.type.iconSVG
        ? `data:image/svg+xml;utf-8, \
          <svg width="30" height="30" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"> \
          <path fill="%233b6bf9" d="${this.type.iconSVG}"></path> \
          </svg>`
        : `data:image/svg+xml;utf-8, \
          <svg width="30" height="30" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"> \
          <path fill="%233b6bf9" d="M12,11.5A2.5,2.5 0 0,1 9.5,9A2.5,2.5 0 0,1 12,6.5A2.5,2.5 0 0,1 14.5,9A2.5,2.5 0 0,1 12,11.5M12,2A7,7 0 0,0 5,9C5,14.25 12,22 12,22C12,22 19,14.25 19,9A7,7 0 0,0 12,2Z"></path> \
          </svg>`;
    },
    icon() {
      //console.log('icon()',this.type.iconSVG)
      return this.type && this.type.iconSVG
        ? `data:image/svg+xml;utf-8, \
         <svg version="1.0" xmlns="http://www.w3.org/2000/svg" width="55.000000pt" height="55.000000pt" viewBox="0 0 100.000000 100.000000" preserveAspectRatio="xMidYMid meet"> \
        <g transform="translate(0.000000,100.000000) scale(0.100000,-0.100000)" fill="%23000000" stroke="none"> \
                <path fill="%233b6bf9" d="${this.type.iconSVG}"/>
        </g> \
        </svg>`
        : `data:image/svg+xml;utf-8, \
          <svg width="30" height="30" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"> \
          <path fill="%233b6bf9" d="M12,11.5A2.5,2.5 0 0,1 9.5,9A2.5,2.5 0 0,1 12,6.5A2.5,2.5 0 0,1 14.5,9A2.5,2.5 0 0,1 12,11.5M12,2A7,7 0 0,0 5,9C5,14.25 12,22 12,22C12,22 19,14.25 19,9A7,7 0 0,0 12,2Z"></path> \
          </svg>`;
    },
  },

  watch: {
    value(newVal) {
      this.name = newVal.name;
      this.description = newVal.description;
      this.lng = newVal.lng;
      this.lat = newVal.lat;
      this.type = { ...newVal.type };
      this.audio = newVal.audio;
    },
  },

  methods: {
    onMapClick(event) {
      //console.log("onmapclick: ", event);
      this.lng = event.latLng.lng();
      this.lat = event.latLng.lat();
    },
    onDragEnd(event) {
      this.lng = event.latLng.lng();
      this.lat = event.latLng.lat();
    },
    onSave() {
      const poi = {
        id: this.value && this.value.id ? this.value.id : undefined,
        name: this.name,
        description: this.description,
        lng: this.lng.toString(),
        lat: this.lat.toString(),
        radius: this.radius,
        type: { ...this.type },
        audio: this.audio,
      };
      this.$emit("input", poi);
      this.$emit("save", poi);
    },
  },
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/gt/itineraries/routes/POIDialog.vue